import { useEffect } from 'react'
import { Formik } from 'formik'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Grid, useMediaQuery, useTheme } from '@mui/material'

import {
  AppVersion,
  AuthContentWrapper,
  AuthFormWrapper,
  AuthHero,
  SignIn2FAVerificationForm,
} from 'src/components'
import { IVerificationCodeForm } from 'src/types'
import { useVerify2FA } from 'src/hooks'

import { codeVerificationSchema } from 'src/common/validations'
import { ROUTES, SPACES } from 'src/constants'
import useStyles from '../styles'

const SignIn2FAVerifyScreen = () => {
  const { mutateAsync: verify2FA } = useVerify2FA()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const classes = useStyles()
  const theme = useTheme()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))

  const token = searchParams.get('token')
  const method = searchParams.get('method')
  const code = searchParams.get('code')

  useEffect(() => {
    if (!token || !method) {
      navigate(ROUTES.LOGIN)
    }
  }, [token, method, navigate])

  const handle2FAVerify = async (values: IVerificationCodeForm) => {
    if (!token) return
    await verify2FA({ code: values.code, token })
  }

  return (
    <AuthContentWrapper>
      <AuthHero />
      <Grid
        px={isLaptop ? SPACES.xxxl : 0}
        item
        xs={isLaptop ? 12 : 6}
        className={classes.contentWrapper}
      >
        <AuthFormWrapper>
          <Formik
            initialValues={{ code: code ? code : '' }}
            onSubmit={handle2FAVerify}
            validationSchema={codeVerificationSchema}
          >
            <SignIn2FAVerificationForm />
          </Formik>
        </AuthFormWrapper>
        <footer className={classes.footerWrapper}>
          <AppVersion />
        </footer>
      </Grid>
    </AuthContentWrapper>
  )
}

export default SignIn2FAVerifyScreen
